import axios from 'axios'

const url = process.env.VUE_APP_URL_API_AIDESFI
const token = process.env.VUE_APP_TOKEN_API_AIDESFI

const aidesService = {
  getAides (codeInsee, filters) {
    let urlEncodedFilters = '?'
    for (var key in filters) {
      if (filters[key]) {
        urlEncodedFilters += key + '=' + filters[key] + '&'
      }
    }
    return axios.get(url + 'aides-locales/' + codeInsee + urlEncodedFilters, {
      headers: {
        'X-AUTH-TOKEN': token
      }
    })
  },

  getDetailAide (idAide) {
    return axios.get(url + 'detail-aide-locale/' + idAide, {
      headers: {
        'X-AUTH-TOKEN': token
      }
    })
  }
}

export default aidesService
